<template>
  <div :class="guideWrap" @click="handleUpload">
    <img :src="imgUrl" class="img">
  </div>
</template>
<script>
import {ua} from '@/utils/common'
import guideUploadWeb from '@/assets/guide_upload_web.png'
import guideUpload from '@/assets/guide_upload.png'

export default {
  data () {
    return {
      imgUrl: ua.wxworkPC ? guideUploadWeb : guideUpload,
      guideWrap: {
        'guide-zone': true,
        'guide-zone-web': ua.wxworkPC,
        'guide-zone-h5': !ua.wxworkPC
      }
    }
  },
  methods: {
    handleUpload () {
      this.$emit('upload-click', true)
    }
  }
}
</script>

<style lang="postcss" scoped>
  .guide-zone {
    /* width: 100%;
    position: fixed; */
    /* bottom: 0;
    left: 0;
    z-index: 1; */
    min-height: 300px;
    background-color: #eeeff5;
    padding-top: 30px;

    & .img {
      vertical-align: top;
    }
  }

  .guide-zone-h5 {
    & .img {
      width: 100%;
    }
  }

  .guide-zone-web {
    display: flex;
    justify-content: center;

    & .img {
      flex: 0 1 auto;
    }
  }
</style>
